<div class="trial-container" [ngStyle]="{ 'padding-left': 'calc(3rem + ' + sideBarWidth + 'px)' }">
    <div class="trial-container__wrapper">
        <div class="trial-container__wrapper__notification">
            <div class="trial-container__wrapper__notification__icon">
                <ng-container *ngIf="(initialInfo$ | async)?.data?.mainMarket?.marcablanca">
                    <i class="fal fa-clock"></i>
                </ng-container>
                <ng-container *ngIf="!(initialInfo$ | async)?.data?.mainMarket?.marcablanca">
                    <i class="fal fa-info-circle"></i>
                </ng-container>
            </div>
            <div class="trial-container__wrapper__notification__text">
                <p class="trial-container__wrapper__notification__text-title">
                    <ng-container *ngIf="(initialInfo$ | async)?.data?.mainMarket?.marcablanca">
                        <span>{{ title.get(bannerType) }}</span> {{ subtitle.get(bannerType) }}
                    </ng-container>
                    <ng-container *ngIf="!(initialInfo$ | async)?.data?.mainMarket?.marcablanca">
                        {{ title.get(bannerType) }} <span>{{ subtitle.get(bannerType) }}</span> 👉
                    </ng-container>
                </p>
                <p class="trial-container__wrapper__notification__text-subtitle">
                    {{ content.get(bannerType) }}
                </p>

                <!-- <p class="trial-container__wrapper__notification__text-subtitle" *ngIf="(initialInfo$ | async)?.data?.mainMarket?.marcablanca">
                    {{ 'app.global.site_info_banner.demo_banner.puedes_restablecer' | translate }}
                </p> -->
            </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="!(initialInfo$ | async)?.data?.mainMarket?.marcablanca">
            <!-- <a
                class="trial-container__wrapper-link"
                href="https://sitiosimple.com/es-ar/planes-precios-pagina-web"
                target="_blank"
            >
                {{ ctaText.get(bannerType) }}
            </a> -->
            <a class="trial-container__wrapper-link" href="{{ ver_planes_link }}" target="_blank">
                {{ ctaText.get(bannerType) }}
            </a>
        </div>
    </div>
    <div class="trial-container__overlayExpired" [ngStyle]="{ 'top.px': alertHeight }"></div>
</div>
